export default {
  baseStyle: {},
  defaultProps: {}
};
//# sourceMappingURL=pressable.js.map